import React, { Component } from "react";
import { connect } from "react-redux";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import produce from "immer";
import { setAutoFreeze } from "immer";
import { calibrationPlotOptions } from "../../constants/highcharts/calibrationPlotOptions";
setAutoFreeze(false); // turns off immer's auto-freeze feature - (it was causing a bug when the number of data points being graphed changed)

const noData = [];
const defaultXmax = 12.4;
const defaultXmin = -0.4;

class CalibrationPlot extends Component {
  constructor(props) {
    super(props);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.state = {
      windowWidth: window.innerWidth * 0.15,
      windowHeight: window.innerHeight > 500 ? 80 : 60,
    };
  }

  updateWindowDimensions() {
    this.setState({
      ...this.state,
      windowWidth: window.innerWidth * 0.15,
      windowHeight: window.innerHeight > 500 ? 80 : 60,
    });
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  render() {
    // Update chart with values from redux store
    const chartOptions = produce(
      { ...calibrationPlotOptions(this.props.theme) },
      (draft) => {
        draft.chart.height = this.state.windowHeight; // resize chart based on screen size (rpi screen vs surface pro)
        draft.chart.width = this.state.windowWidth;

        // xAxis
        draft.xAxis.min = this.props.xMin;
        draft.xAxis.max = this.props.xMax;

        // data
        draft.series[0].data = this.props.data;
        draft.series[1].data = this.props.depthLine;
      }
    );

    return (
      <HighchartsReact
        // containerProps={{ style: { width: "180px", height: "50px" } }}
        options={chartOptions}
        highcharts={Highcharts}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const aLineData = state.device.aLineData;
  return {
    xMin: aLineData.calibration_data ? null : defaultXmin,
    xMax: aLineData.calibration_data ? null : defaultXmax,
    data: aLineData.calibration_data || noData,
    depthLine: aLineData.depth_line || noData,
    theme: state.utility.theme,
  };
};

export default connect(mapStateToProps)(CalibrationPlot);
